import { StringField } from "../../../types/types";
import {
  TLanguageCollection,
  TPrivacyContentItems,
  TPrivacyStatementFields,
  TPrivacyStatementProps,
  TTypeCollection,
} from "../types/PrivacyStatement.types";

export class PrivacyStatementModel {
  private readonly fields?: TPrivacyStatementFields;

  constructor(props: TPrivacyStatementProps) {
    this.fields = props.fields;
  }

  get title(): StringField {
    return this.fields?.privacyContent?.privacyStatementTitle || {value: ''};
  }

  get items(): TPrivacyContentItems[] {
    return this.fields?.privacyContent?.items ?? [];
  }

  get itemIds(): string[] {
    return this.items?.map((item) => item.id);
  }

  get languageCollection(): TLanguageCollection[] {
    return this.fields?.languageCollection ?? [];
  }

  get typeCollection(): Map<string, string[]> {
    const typeCollectionArray = this.fields?.typeCollection || [];
    const typeCollectionMap = new Map(typeCollectionArray.map((x) =>[Object.keys(x)[0], [...Object.values(x)[0]]]));
    return typeCollectionMap;
  }

  get typeCollectionArray(): string[] {
    const typeCollectionArray = this.fields?.typeCollection || [];
    return typeCollectionArray.map(x => Object.keys(x)[0]);
  }

  get languageTitle(): StringField {
    return this.fields?.languageTitle ?? {value: ''};
  }

  get defaultLanguageTitle(): StringField {
    return this.fields?.privacyContent?.languageTitle ?? {value: ''};
  }

  get typeTitle(): StringField {
    return this.fields?.typeTitle ?? {value: ''};
  }

  get defaultEmptyMessage(): StringField {
    return this.fields?.defaultEmptyMessage ?? {value: ''};
  }
}
